import { render, staticRenderFns } from "./CardFront.vue?vue&type=template&id=530619bc&scoped=true"
var script = {}
import style0 from "./CardFront.vue?vue&type=style&index=0&id=530619bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530619bc",
  null
  
)

export default component.exports